export default "__VITE_ASSET__a2bf2954__"